import {useState, useEffect} from 'react';

const format = (time) => {
    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / (60 * 1e3));
    time -= minutes * (60 * 1e3);

    const seconds = Math.floor(time / 1e3);

    return `${hours >= 10 ? hours : `0${hours}`}:${minutes >= 10 ? minutes : `0${minutes}`}:${seconds >= 10 ? seconds : `0${seconds}`}`;
}

export default ({
    timeout,
    children
}) => {
    const [time, setTime] = useState(timeout - Date.now());

    useEffect(() => {
        setTime(timeout - Date.now());
    }, [timeout])

    useEffect(() => {
        if(time > 0)
            window.wheel_timer_timeout = setTimeout(() => {
                setTime(timeout - Date.now());
            }, 500);
    }, [time]);

    useEffect(() => {
        return () => window.clearTimeout(window.wheel_timer_timeout);
    }, []);

    if(time > 0)
        return (
            <div className="spin-button timer">
                <span>{format(time)}</span>
            </div>
        )

    return children;
}